import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Twitter, ExternalLink } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative z-20 px-8 lg:px-16 py-12 mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto">
        <div className="glass-card p-8 md:p-12 rounded-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <img 
                  src="/solara-logo.png" 
                  alt="Solara Global Capital" 
                  className="h-12 w-12 object-contain"
                />
              </Link>
              <p className="text-slate-400 text-sm leading-relaxed mb-4">
                Premium property finance for Australia's leading developers and strategic acquirers.
              </p>
              <div className="flex gap-3">
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-sm bg-slate-800/50 flex items-center justify-center text-slate-400 hover:text-[#bd9a59] hover:bg-slate-800 transition-all"
                  data-testid="footer-linkedin"
                >
                  <Linkedin className="w-4 h-4" />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-sm bg-slate-800/50 flex items-center justify-center text-slate-400 hover:text-[#bd9a59] hover:bg-slate-800 transition-all"
                  data-testid="footer-twitter"
                >
                  <Twitter className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  { name: "About Us", path: "/about" },
                  { name: "Services", path: "/services" },
                  { name: "Contact", path: "/contact" },
                  { name: "Book a Call", path: "/booking" },
                ].map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-slate-400 text-sm hover:text-[#bd9a59] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
                Services
              </h4>
              <ul className="space-y-3">
                {[
                  "Development Finance",
                  "Construction Loans",
                  "Land Acquisition",
                  "Mezzanine Funding",
                ].map((service) => (
                  <li key={service}>
                    <span className="text-slate-400 text-sm">{service}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
                Contact
              </h4>
              <ul className="space-y-4">
                <li>
                  <a
                    href="tel:1300021888"
                    className="flex items-start gap-3 text-slate-400 text-sm hover:text-[#bd9a59] transition-colors"
                    data-testid="footer-phone"
                  >
                    <Phone className="w-4 h-4 mt-0.5 text-[#bd9a59]" />
                    <span>1300 021 888</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:loans@sgcap.com.au"
                    className="flex items-start gap-3 text-slate-400 text-sm hover:text-[#bd9a59] transition-colors"
                    data-testid="footer-email"
                  >
                    <Mail className="w-4 h-4 mt-0.5 text-[#bd9a59]" />
                    <span>loans@sgcap.com.au</span>
                  </a>
                </li>
                <li className="flex items-start gap-3 text-slate-400 text-sm">
                  <MapPin className="w-4 h-4 mt-0.5 text-[#bd9a59]" />
                  <span>
                    Level 1, 60 Martin Place<br />
                    Sydney, NSW 2000
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-xs">
              © {new Date().getFullYear()} Solara Global Capital. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-slate-500 text-xs hover:text-slate-300 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-500 text-xs hover:text-slate-300 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
